import { api } from "../../http";

async function GetDataAllProdutos() {
  try {
    
    const data = await api.get(`/produtos`);
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { GetDataAllProdutos };
